import React, { useEffect, useState } from 'react';
import DropDownOptions, { Lookup } from 'devextreme-react/lookup';
import { Container, Row, Col } from 'reactstrap';
import { MasterDataGrid } from "@/components/";
import { Button } from 'reactstrap';
import FollowupAdminPresenter from "../../../presenters/screens/followup-admin.presenter";
import { IFollowupAdmin } from "@interfaces/screens/followup-admin.interface";
import { Toast } from "devextreme-react/toast";
import styles from './admin.module.scss';

interface IAdminBySubprojectProps{
    dataColumns: any,
}

const AdminBySubproject: React.FC<IAdminBySubprojectProps> = ({dataColumns} : IAdminBySubprojectProps) => {
    
    const [followData, setFollowData] = useState([]);
    const [projects, setProjects] = useState<any>([]);
    const [subprojects, setSubProjects] = useState<any>([]);
    const [subProjectData, setSubProjectData] = useState<any>([]);
    const [dimensionsData, setDimensionData] = useState<any>([]);
    const [monthData, setMonthData] = useState<any>([]);

    const [monthsData, setMonthsData] = useState<any>([]);
    const [yearsData, setYearsData] = useState<any>([]);

    const [projectSelected, setProjectSelected] = useState<any>(null);
    const [subProjectSelected, setSubProjectSelected] = useState<any>(null);
    const [yearSelected, setYearSelected] = useState<any>(null);
    const [dimensionSelected, setdimensionSelected] = useState<any>(null);

    const [stateSubProject, setStateSubProject] = useState<string>("Vigente");

    const [hasChanged, setHasChanged] = useState<boolean>(false);

    const [toastConfig, setToastConfig] = React.useState({
		isVisible: false,
		type: null,
		message: "",
	});

    const view: IFollowupAdmin = {
        state: {
            followData: followData,
            projectSelected: projectSelected,
            subProjectSelected: subProjectSelected,
            stateSubProject: stateSubProject,
            subProjectData: subProjectData,
            yearSelected: yearSelected,
            dimensionSelected: dimensionSelected,
            monthData: monthData,
            monthsData: monthsData,
            dataColumns: dataColumns,
            toastConfig: toastConfig,
            dimensionsData: dimensionsData,
            yearsData: yearsData,
            hasChanged: hasChanged,
            setYearsData: setYearsData,
            setFollowData: setFollowData,
            setYearSelected: setYearSelected,
            setDimensionData: setDimensionData,
            setdimensionSelected: setdimensionSelected,
            setMonthData: setMonthData,
            setMonthsData: setMonthsData,
            setSubProjects: setSubProjects,
            setProjectSelected: setProjectSelected,
            setStateSubProject: setStateSubProject,
            setSubProjectData: setSubProjectData,
            setSubProjectSelected: setSubProjectSelected,
            setToastConfig: setToastConfig,
            setHasChanged: setHasChanged
        },
    };
      
    const presenter = new FollowupAdminPresenter(view);
    
    useEffect(() => {
        if(presenter.formMasters && presenter.followupData.length) presenter.getData(presenter.followupData, presenter.formMasters)
    }, [presenter.formMasters, presenter.followupData]);

    useEffect(()=>{
        let auxProjects: any[] = []
        if(followData.length){
            followData.forEach((item:any) => {
                if(!auxProjects.includes(item.project)) auxProjects.push(item.project);
            });
            setProjects(auxProjects);
        }
    },[followData])

    const render = (projects:any) => {
        return (
            <>
                <Container fluid style={{marginBottom: '30px'}}>
                    <Row xs="4" sm="4" md="4" lg="4" xl="4">
                        <Col>
                            <div className="dx-fieldset-header">{presenter.followupLabels.get("projects")}</div>
                            <div className="dx-field">
                                <Lookup
                                    value={projectSelected}
                                    items={projects}
                                    defaultValue={projects[0]}
                                    onValueChanged={presenter.onProjectChanged}
                                >
                                <DropDownOptions />
                                </Lookup>
                            </div>
                        </Col>
                        {projectSelected && <Col>
                            <div className="dx-fieldset-header">{presenter.followupLabels.get("subProjects")}</div>
                            <div className="dx-field">
                                <Lookup
                                    value={subProjectSelected}
                                    items={subprojects}                                    
                                    displayExpr={presenter.getDisplayExpression}
                                    onValueChanged={presenter.onSubProjectChanged}
                                >
                                <DropDownOptions />
                                </Lookup>
                            </div></Col>
                        }
                        {subProjectSelected && <Col>                        
                            <div className="dx-fieldset-header">{presenter.followupLabels.get("state")}</div>
                            <div className="dx-field">
                                <Lookup
                                    value={stateSubProject}
                                    displayExpr="Title" valueExpr="ID"
                                    items={presenter.getSubprojectsStateItems()}
                                    onValueChanged={e => {
                                        setStateSubProject(e.value)
                                        setHasChanged(true)
                                    }}
                                >
                                    <DropDownOptions />
                                </Lookup>
                            </div></Col>
                        }
                        <div style={{display: "flex", justifyContent: "left", alignContent: "center", alignItems: "flex-end"}}>
                            <Button color="primary" onClick={() => presenter.saveData()}>{presenter.followupLabels.get("saveChanges")}</Button>
                        </div>
                    </Row>
                    <Row xs="2" sm="2" md="2" lg="2" xl="2">
                        {subProjectSelected && <Col>
                            <MasterDataGrid
                                id={`${subProjectSelected.projectId}-${subProjectSelected.id}-admin-subprojects`}
                                dataSource={subProjectData}
                                keyExpr={"id"}
                                columns={presenter.getSubProjectsColumns()}
                                gridProps={presenter.getSubprojectsGrids()}
                            /></Col>
                        }
                        {yearSelected && <Col>
                            <MasterDataGrid
                                id={`${yearSelected?.subProyectoAnio}-admin-dimensiones`}
                                dataSource={dimensionsData}
                                columns={presenter.getDimensionsColumns()}
                                gridProps={{...presenter.getDimensionsGrids(), onContentReady: (data) => {
                                    if(data.component !== undefined){
                                        const indexTotal = data.component.getVisibleRows().length -1;
                                        const total = data.component.getRowElement(indexTotal);
                                        if(total !== undefined){
                                            total[0].classList.add(styles.readOnly);
                                        }
                                    }
                                }}}
                                onCellClick={presenter.onCellClick}
                            /></Col>
                        }
                        {dimensionSelected && <Col>
                            <MasterDataGrid 
                                id={`${yearSelected?.subProyectoAnio}-admin-dimension-month`}
                                dataSource={monthData}
                                columns={presenter.getDimensionsMonthsColumns()}
                                gridProps={presenter.getDimensionsMonthsGrids()}
                            /></Col>
                        }
                    </Row>
                </Container>
                <Toast
                    visible={toastConfig.isVisible}
                    message={toastConfig.message}
                    type={toastConfig.type}
                    onHiding={presenter.onHidingToast}
                    displayTime={5000}
                />
            </>
        );
    }

    if(projects.length) return render(projects)
    else return <div></div>
}

export default AdminBySubproject;